import React from "react";

const Cardcursoprompt = () => {

    return(
        <div className="w3-card-4 w3-margin w3-quarter livecard">
            <a href="curso-prompt-engineering"><img className="card-image" src="curso-prompt-engineering.jpeg" alt="Curso Python AI desde cero" width="100%"/></a> 
            <div className="container w3-padding-32" style={{paddingLeft: '32px', paddingRight: '32px'}}>
                <h2>Curso Prompt Engineering</h2>
                <h5>Aprenderás los principios y técnicas básicas del prompt engineering(ingeniería de prompts) para lograr dialogar con los Lenguajes de Gran Tamaño (LLMs), como ChatGPT de forma eficaz.</h5>
                <div className="w3-flex" style={{alignItems:'center', flexDirection:'column'}}>
                    <p className="w3-large">Saber más sobre el Curso de Prompt Engineering Gratuito</p>
                    <div className="circle w3-xxlarge w3-center"><a style={{textDecoration: 'none'}} href="curso-prompt-engineering"><strong>→</strong></a></div>
                </div>
            </div>
        </div>
    );
}

export default Cardcursoprompt;